export default __webpack_public_path__ + "static/media/adress.5e7cd6cb.svg";